// Tied to backend, do not rename values
export enum CsvInteractionExportField {
    CONTACT_NAME = 'CONTACT_NAME',
    INTERACTION_TIME = 'INTERACTION_TIME',
    OUTLET_NAME = 'OUTLET_NAME',
    INTERACTION_SUMMARY = 'INTERACTION_SUMMARY',
    INTERACTION_TYPE = 'INTERACTION_TYPE',
    INTERACTION_NOTES = 'INTERACTION_NOTES',
    INTERACTION_DATE = 'INTERACTION_DATE',
    USERNAME = 'USERNAME'
}

// Define the predefined order
export const csvInteractionFieldOrder: CsvInteractionExportField[] = [
    CsvInteractionExportField.CONTACT_NAME,      // Contact Name
    CsvInteractionExportField.OUTLET_NAME,       // Outlet Name
    CsvInteractionExportField.INTERACTION_TYPE,  // Type
    CsvInteractionExportField.INTERACTION_SUMMARY, // Summary
    CsvInteractionExportField.INTERACTION_NOTES, // Notes
    CsvInteractionExportField.INTERACTION_DATE,  // Date
    CsvInteractionExportField.INTERACTION_TIME,  // Time
    CsvInteractionExportField.USERNAME           // Username
];
